<template>
  <v-row no-gutters id=mainDivGoogleRouteHistory>
    <div v-show="speedChip !== undefined" id="divtoshow" style="position: absolute; z-index:10;"> <v-chip
      class="ma-2"
      x-small
      color="primary"
    >
      {{ speedChip }} km/h
    </v-chip></div>
    <GmapMap
      @click="mapClick"
      ref="map"
      :center="{lat: 44.801545, lng:20.458796}"
      :zoom="7"
      :options="{ streetViewControl: false }"
      style="width: 100%;"
      :class="fullHeightMap ? 'mapFullHeight' : 'mapNotFullHeight'"
    >
      <gmap-polyline v-for="(route, index) in optimizedRoutes" :key="'poly-' + index"
        v-if="route.visible" :path="route.path"
        :options="{ strokeColor: 'green', strokeWeight : 3 }">
      </gmap-polyline>

      <template v-if="showRouteHistory">
        <template v-for="(marker, index) in stops">
          <GmapMarker
            :key="index"
            :position="marker.position"
            @click="markerClick(marker)"
            :icon="createGmapMarkerIcon(marker.stopNumber, '42c2f5', '000000')"
          >
            <GmapInfoWindow v-if="stopToDisplay == marker" @closeclick="mapClick">
              <p>{{ translate('Number', 'realtimeMap') }}: {{ marker.stopNumber }}</p>
              <p>{{ translate('Stop duration', 'realtimeMap') }}: {{marker.stopDuration}}</p>
              <p>{{ translate('Time', 'realtimeMap') }}: {{ convertDate(marker.timestamp)}}</p>
            </GmapInfoWindow>
          </GmapMarker>
        </template>
      </template>

      <template v-if="!showRouteHistory">
        <template v-for="route in privateBusinessDriveRoutesToDisplay">
          <GmapPolyline 
            :key="route.id"
            :path="route.coordinates"
            :options="{ strokeColor: route.strokeColor, strokeOpacity: 1, strokeWeight: 4 }"
          ></GmapPolyline>
        </template>
      </template>      

      <template v-if="showRouteHistory">
        <template v-for="route in routesToDisplay">
          <GmapPolyline
            @mouseenter="info"
            @mousemove="info"
            @mouseout="speedChip = undefined"
            :key="route.id"
            :path="route.coordinates"
            :options="{ strokeColor: route.strokeColor, icons : displayRouteDirections? route.icons : null, strokeOpacity: route.strokeOpacity, strokeWeight : route.strokeWeight  }"
          ></GmapPolyline>
        </template>
      </template>
      
      <GmapPolyline
        @mouseenter="info"
        @mousemove="info"
        @mouseout="speedChip = undefined"
        v-if="routeSlice"
        key="slice"
        :path="routeSlice.coordinates"
        :options="{ strokeColor: 'black', zIndex: 3, strokeWeight : 6 }"
      ></GmapPolyline>
      <GmapMarker
        v-if="singleVehiclePoint"
        key="singleVehiclePoint"
        :position="singleVehiclePoint.position"
        :options="{ zIndex: 10}"
        :icon="getVehicleIcon(singleVehiclePoint)"
        @click="singleVehicleClick"
      >
        <GmapInfoWindow v-if="showSingleVehiclePopUp" @closeclick="mapClick">
          <p>{{ translate('Driver Name', 'realtimeMap') }}: {{ singleVehiclePoint.driver }}</p>
          <p>{{ translate('Speed', 'realtimeMap') }}: {{singleVehiclePoint.speed}}</p>
          <p>{{ translate('Time', 'realtimeMap') }}: {{convertDate(singleVehiclePoint.timestamp)}}</p>
        </GmapInfoWindow>
      </GmapMarker>
    </GmapMap>

    <div v-if="numberOfVehicles > 1 || optimizedRoutes.length > 1" class="routeHistoryLegend ma-2" :class="{'legendWithTable': tableData && displayTable}" id="legend">
      <v-card class="legendBlock">
        <p class="ml-1">Legenda:</p>
        <v-list>
          <v-list-item-group>
            <v-list-item
              v-for="(vehicle, index) in vehiclesForLegend"
              :key="index"
              @click="zoomToRoute(vehicle)"
              class="vehicleListItem"
            >
              <v-list-item-title>
                <v-chip
                  :color="vehicleColors[index]"
                  small
                  class="ml-1"
                >{{ legendSource == 'vehicle' ? vehicle[0].vehicleLabel : vehicle[0].driverName }}</v-chip>
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="optimizedRoutes.length > 1"
              class="vehicleListItem"
            >
              <v-list-item-title>
                <v-chip
                  color="green"
                  small
                  class="ml-1"
                  @click="zoomToRoute(optimizedRouteForLegend)"
                >{{ translate('Optimized route', 'realtimeMap') }}</v-chip>
              </v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </div>

    <template>
      <v-col>
        <RouteHistoryResult v-if="tableData && displayTable" :routes="tableData" />
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import store from '@/store/store'
import { getRoutesGroupedBy } from '../../../utils/map/routesGroupedBy'
import { gmapApi } from 'vue2-google-maps'
import EventBus from '../../../event-bus'
import BaseGoogleMapComponent from '../BaseGoogleMapComponent'
import translate from '@/utils/genTable/multilanguageHelper.js'
import formatDate from '@/utils/formatDateHelper.js'
import { createGmapMarkerIcon } from '../../../utils/map/createGmapMarkerIcon'
export default {
  extends: BaseGoogleMapComponent,
  components: {
    RouteHistoryResult: () =>
      import('@/components/map/route/RouteHistoryResult')
  },
  data() {
    return {
      markers: {},
      openedInfoWindows: [],
      stops: [],
      routesToDisplay: [],
      stopToDisplay: null,
      routeSlice: null,
      singleVehiclePoint: null,
      showSingleVehiclePopUp: false,
      numberOfVehicles: 0,
      vehiclesForLegend: [],
      speedChip: undefined,
      optimizedRouteForLegend: [],
      privateBusinessDriveRoutesToDisplay: [],
      showRouteHistory: true,
      createGmapMarkerIcon: createGmapMarkerIcon,
      firstMarkers: [],
      lastMarkers: []
    }
  },
  computed: {
    ...mapState('history', [
      'routes',
      'vehicleColors',
      'fullHeightMap',
      'maxSpeed',
      'tableData',
      'routeSegment',
      'displayRouteDirections',
      'legendSource',
      'displayTable',
      'searchObject',
      'routeOptimizationData',
      'privateDriveRoutes',
      'businessDriveRoutes'
    ]),
    google: gmapApi,
    map: gmapApi,
    optimizedRoutes() {
      return this.routeOptimizationData && Object.keys(this.routeOptimizationData).length != 0
        ? this.routeOptimizationData.routes.map(x => {
            return {
              color: x.color,
              visible: x.visible,
              width: x.width,
              path: x.coordinates.map(x => {
                return {
                  lat: x[0],
                  lng: x[1]
                }
              })
            }
          })
        : []
    }
  },
  mounted() {
    var that = this
    EventBus.$on('ROUTE_HISTORY_GO_TO_START', function() {
      that.fitBounds([that.routesToDisplay[0].coordinates[0]])
    })

    EventBus.$on('ROUTE_HISTORY_SHOW_SELECTED_ROW_POSITION_ON_MAP', function(
      item
    ) {
      item = item.markers[0]
      that.singleVehiclePoint = {}
      that.singleVehiclePoint.position = {
        lat: item.latitude,
        lng: item.longitude
      }
      that.singleVehiclePoint.showPopUp = false
      that.singleVehiclePoint.timestamp = item.timestamp
      that.singleVehiclePoint.speed = item.speed
      that.singleVehiclePoint.driver = item.driverName
      that.fitBounds([that.singleVehiclePoint.position], true)
    })

    EventBus.$on('ROUTE_HISTORY_GO_TO_END', function() {
      that.fitBounds([
        that.routesToDisplay[0].coordinates[
          that.routesToDisplay[0].coordinates.length - 1
        ]
      ])
    })
  },
  methods: {
    info(route) {
      var left = route.domEvent.pageX - 10 + 'px'
      var top = route.domEvent.pageY - 35 + 'px'

      var div = document.getElementById('divtoshow')

      div.style.left = left
      div.style.top = top

      var point = new this.google.maps.LatLng(
        this.conv(route.latLng.lat()),
        this.conv(route.latLng.lng())
      )
      for (let route of this.routesToDisplay) {
        for (let i = 0, j = 1; j < route.coordinates.length; i++, j++) {
          var first = route.coordinates[i]
          var second = route.coordinates[j]
          if (!first || !second) {
            break
          }
          var line = new this.google.maps.Polyline({
            path: [
              { lat: this.conv(first.lat), lng: this.conv(first.lng) },
              { lat: this.conv(second.lat), lng: this.conv(second.lng) }
            ]
          })
          if (
            this.google.maps.geometry.poly.isLocationOnEdge(point, line, 1e-4)
          ) {
            this.speedChip = first.speed
            break
          }
        }
      }
    },
    conv(coordinate) {
      var beforePoint = coordinate.toString().split('.')[0]
      var afterPoint = coordinate
        .toString()
        .split('.')[1]
        .substr(0, 6)

      let newCoordinate = beforePoint + '.' + afterPoint
      return Number(newCoordinate)
    },
    singleVehicleClick() {
      this.showSingleVehiclePopUp = true
    },
    getVehicleIcon(vehicle) {
      var iconColor = 'greencar'

      if (vehicle.color == 1) {
        iconColor = 'greencar'
      } else if (vehicle.color == 2) {
        iconColor = 'bluecar'
      } else {
        iconColor = 'redcar'
      }

      if (vehicle.poi) {
        iconColor = iconColor + 'animated'
      }
      return {
        url: `${process.env.VUE_APP_S3_DOMAIN}/icons/car.png?i=${iconColor}`,
        scaledSize: { width: 30, height: 30, f: 'px', b: 'px' }
      }
    },
    fitBounds(coordinates, distantZoom = false) {
      this.$refs.map.$mapPromise.then(map => {
        var bounds = new this.google.maps.LatLngBounds()
        for (var i = 0; i < coordinates.length; i++) {
          bounds.extend(coordinates[i])
        }
        if (distantZoom) {
          map.fitBounds(bounds)
          map.setZoom(16)
        } else {
          map.fitBounds(bounds)
        }
      })
    },
    mapClick() {
      this.stopToDisplay = null
      this.showSingleVehiclePopUp = false
    },
    markerClick(marker) {
      this.stopToDisplay = marker
    },
    convertDate(date) {
      return formatDate(date, 'long', true)
    },
    translate(engText, translatePath) {
      return translate(engText, translatePath)
    },
    handleRouteChange(routeData) {
      this.routesToDisplay = []
      this.stops = []
      this.routeSlice = null
      this.vehiclesForLegend = []
      this.numberOfVehicles = 0

      var routesGroupedByImeis
      if (this.searchObject.VehicleIds) {
        routesGroupedByImeis = getRoutesGroupedBy(routeData, 'imei')
      } else {
        routesGroupedByImeis = getRoutesGroupedBy(routeData, 'driverName')
      }

      this.firstMarkers.forEach(firstMarker => firstMarker.setMap(null))
      this.lastMarkers.forEach(lastMarker => lastMarker.setMap(null))
      this.firstMarkers = []
      this.lastMarkers = []

      var allRoutes = []
      let counter = 0
      routesGroupedByImeis.forEach(imeRoutes => {
        let color = this.vehicleColors[counter++]
        let stopCount = 1

        this.vehiclesForLegend.push(imeRoutes)
        imeRoutes.forEach(route => {
          allRoutes.push({
            lat: route.latitude,
            lng: route.longitude,
            timestamp: route.timestamp,
            speed: route.speed
          })

          if (!route.isMoving) {
            this.stops.push({
              position: {
                lat: route.latitude,
                lng: route.longitude,
                timestamp: route.timestamp
              },
              stopNumber: stopCount++,
              openedInfoWindow: false,
              timestamp: route.timestamp,
              stopDuration: route.stopDuration
            })
          }
        })

        this.routesToDisplay.push({
          coordinates: allRoutes,
          strokeColor: color,
          strokeOpacity: 1.0,
          strokeWeight: 6,
          icons: [
            {
              icon: {
                path: 1,
                scale: 3,
                strokeColor: 'black',
                zIndex: 1
              },
              offset: '0',
              repeat: '100px'
            }
          ]
        })
        allRoutes = []

        this.numberOfVehicles++

        let overSpeedings = []
        for (let route of imeRoutes) {
          if (route.allowedSpeed && route.speed > route.allowedSpeed) {
            overSpeedings.push({
              speed: route.speed,
              lat: route.latitude,
              lng: route.longitude
            })
          } else {
            if (overSpeedings.length) {
              this.routesToDisplay.push({
                isSpeeding: true,
                coordinates: overSpeedings,
                strokeColor: 'red',
                strokeOpacity: 1.0,
                strokeWeight: 6,
                icons: [
                  {
                    icon: {
                      path: 1,
                      scale: 3,
                      strokeColor: 'black',
                      zIndex: 1
                    },
                    offset: '0',
                    repeat: '150px'
                  }
                ]
              })
            }
            overSpeedings = []
          }
          this.firstAndLastRouteHistoryMarkers(imeRoutes)
        }
      })

      let routesToZoomIn = []

      this.routesToDisplay.forEach(r => {
        r.coordinates.forEach(c => routesToZoomIn.push(c))
      })

      this.fitBounds(routesToZoomIn)
      store.dispatch('history/isDrawing', false)
    },
    handleRouteOptimization() {
      let routesToZoomIn = []
      for (const route of this.optimizedRoutes) {
        route.path.forEach(coordinate => this.optimizedRouteForLegend.push({latitude: coordinate.lat, longitude: coordinate.lng}))
        routesToZoomIn = routesToZoomIn.concat(route.path)
      }
      if (routesToZoomIn.length) {
        this.fitBounds(routesToZoomIn)
      }
    },
    handlePrivateBusinessDriveChange() {
      this.privateBusinessDriveRoutesToDisplay = []
      let privateBusinessArray = []

      if(this.searchObject.privateDrive && this.searchObject.businessDrive) {
        privateBusinessArray = this.privateDriveRoutes.concat(this.businessDriveRoutes)
      } else if (this.searchObject.privateDrive) {
        privateBusinessArray = this.privateDriveRoutes
      } else if (this.searchObject.businessDrive) {
        privateBusinessArray = this.businessDriveRoutes
      }

      if(this.searchObject.privateDrive || this.searchObject.businessDrive) {
        privateBusinessArray.forEach(route => {
          let routeObj = {}
          routeObj.coordinates = []

          if(route[0].ioEventName == 'Privatna') {
            routeObj.strokeColor = '#F44336'            
          } else if (route[0].ioEventName == 'Službena') {
            routeObj.strokeColor = '#3F51B5'
          }
          route.forEach(point => {
            routeObj.coordinates.push({ lat: point.latitude, lng: point.longitude, speed: point.speed, timestamp: point.timestamp })
          })
          this.privateBusinessDriveRoutesToDisplay.push(routeObj)

          this.firstMarkers.forEach(firstMarker => firstMarker.setMap(null))
          this.lastMarkers.forEach(firstMarker => firstMarker.setMap(null))
        })
        this.showRouteHistory = false
      } else {
        this.showRouteHistory = true

        this.$refs.map.$mapPromise.then(map => { 
          if (this.firstMarkers && this.firstMarkers.length) {
            this.firstMarkers.forEach(firstMarker => firstMarker.setMap(map))
          }

          if (this.lastMarkers && this.lastMarkers.length) {
            this.lastMarkers.forEach(lastMarker => lastMarker.setMap(map))
          }
        })

      }
    },
    firstAndLastRouteHistoryMarkers(allRoutes) {
      this.$refs.map.$mapPromise.then(map => {
        var firstPoint = allRoutes[0]
        var lastPoint = allRoutes[allRoutes.length - 1]

        var firstMarker = new this.google.maps.Marker ({
          position: { lat: firstPoint.latitude, lng: firstPoint.longitude },
          icon: createGmapMarkerIcon('P', '009933', 'ffffff'),
          map
        });
        this.firstMarkers.push(firstMarker)
  
        var lastMarker = new this.google.maps.Marker ({
          position: { lat: lastPoint.latitude, lng: lastPoint.longitude },
          icon: createGmapMarkerIcon('K', 'ff9933', '000000'),
          map
        });
        this.lastMarkers.push(lastMarker)

      })
    }
  },
  watch: {
    routes: {
      handler() {
        this.handleRouteChange(this.routes)
        this.handleRouteOptimization()
      }
    },
    routeSegment: {
      handler() {
        if (this.routeSegment) {
          this.routeSlice = {}
          this.routeSlice.coordinates = []

          for (let r of this.routesToDisplay) {
            if (r.isSpeeding) {
              continue
            }
            for (let c of r.coordinates) {
              let routeDate = new Date(c.timestamp)
              let stopSegmentTime = new Date(
                this.routeSegment.route.stopPoint.time
              )
              let startSegmentTime = new Date(
                this.routeSegment.route.startPoint.time
              )
              if (routeDate > stopSegmentTime) {
                break
              }
              if (routeDate < startSegmentTime) {
                continue
              }
              this.routeSlice.coordinates.push({
                lat: c.lat,
                lng: c.lng
              })
            }
          }
          this.fitBounds(this.routeSlice.coordinates)
        } else {
          this.routeSlice = null
        }
      }
    },
    searchObject: {
      deep: true,
      handler() {
        this.handlePrivateBusinessDriveChange()
      }
    },
  }
}
</script>

<style>
#mainDivGoogleRouteHistory #googleMap {
  width: 100%;
  height: 863px;
}
#mainDivGoogleRouteHistory .mapFullHeight {
  height: 94.4vh;
}
#mainDivGoogleRouteHistory .mapNotFullHeight {
  height: 60.4vh;
}
#mainDivGoogleRouteHistory .gm-style-iw {
  max-width: 200px !important;
}
#mainDivGoogleRouteHistory #legend {
  z-index: 1000 !important;
  position: absolute !important;
  left: 0px !important;
  bottom: 0px !important;
}
#mainDivGoogleRouteHistory .legendBlock {
  padding: 10px;
  padding-bottom: 0px;
}
#mainDivGoogleRouteHistory .vehicleListItem {
  margin-bottom: 15px;
}
#mainDivGoogleRouteHistory .legendBlock p {
  margin-bottom: 5px;
}

@media (min-width: 960px) {
  #mainDivGoogleRouteHistory #legend.legendWithTable {
    bottom: 260px !important;
  }
}

@media (min-width: 1576px) {
  #mainDivGoogleRouteHistory #legend.legendWithTable {
    bottom: 330px !important;
  }
}
</style>
